import { navigate } from "gatsby-link"
import { useEffect } from "react"

import { useBookingInviteQuery } from "~graphql/generated/graphql"

export default function useBookingInviteWithRedirect(
    id: string | null | undefined
) {
    const {
        data,
        loading: isLoadingBookingInvite,
        error,
    } = useBookingInviteQuery({
        variables: { id: id ?? "" },
        fetchPolicy: "no-cache",
        skip: !id,
    })
    const bookingInvite = data?.bookingInvite
    const redirectUrl = bookingInvite?.booked_redirect_url
    const isRedirecting = Boolean(redirectUrl)

    // Continue loading if redirecting, so we don't show flash the checkout UI.
    const isLoading = isLoadingBookingInvite || isRedirecting

    useEffect(() => {
        if (!redirectUrl) return

        void navigate(redirectUrl)
    }, [redirectUrl])

    return { bookingInvite, isLoading, isRedirecting, error }
}
